<template>
	<v-dialog
    v-model="timeSelectorDialog"
    width="700"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="#0098E1"
        dark
        style="float: right"
        v-on="on"
      >
        <v-icon class="p-right">access_time</v-icon>
        {{$t("TimeFilter.capitalizedFrom")}}: {{fromDateLocaleString}} {{$t("TimeFilter.capitalizedTo")}}: {{toDateLocaleString}}
      </v-btn>
      <v-btn text icon
        color="#0098E1"
        @click="refreshTime"
        style="float: right"
      >
        <v-icon>cached</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-layout wrap>
        <v-card class="time-filter-modal">
          <v-card-title primary-title>
            <b>{{$t("TimeFilter.customRange")}}</b>
          </v-card-title>
          <v-subheader>
            <b>{{$t("TimeFilter.from")}}</b>
          </v-subheader>
          <v-container class="date-time-flex">
            <div class="date-time-selectors">
              <v-icon color="#0098E1">
                access_time
              </v-icon>
              <datetime type="time" v-model="fromDateString" format="hh:mm a" use12-hour class="theme-ponce"></datetime>
            </div>
            <div class="date-time-selectors">
              <v-icon color="#0098E1">
                event
              </v-icon>
              <datetime type="date" value-zone="local" v-model="fromDateString" format="dd/MM/yyyy" class="theme-ponce"></datetime>
            </div>
          </v-container>
          <v-subheader>
            <b>{{$t("TimeFilter.to")}}</b>
          </v-subheader>
          <v-container class="date-time-flex">
            <div class="date-time-selectors">
              <v-icon color="#0098E1">
                access_time
              </v-icon>
              <datetime type="time" v-model="toDateString" format="hh:mm a" use12-hour class="theme-ponce"></datetime>
            </div>
            <div class="date-time-selectors">
              <v-icon color="#0098E1">
                event
              </v-icon>
              <datetime type="date" value-zone="local" v-model="toDateString" format="dd/MM/yyyy" class="theme-ponce"></datetime>
            </div>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="onApply">{{$t("TimeFilter.customRange")}}</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="time-filter-modal">
          <v-card-title primary-title>
            <b>{{$t("TimeFilter.quickSelection")}}</b>
          </v-card-title>
          <v-layout wrap>
            <div class="time-filter-modal">
              <v-btn text @click="onQuickSelect('oneHour', $ponceConfig.timerTypes['diffHours'])">{{$t("TimeFilter.lastHour")}}</v-btn>
              <v-btn text @click="onQuickSelect('sixHours', $ponceConfig.timerTypes['diffHours'])">{{$t("TimeFilter.lastSixHours")}}</v-btn>
              <v-btn text @click="onQuickSelect('oneDay', $ponceConfig.timerTypes['diffHours'])">{{$t("TimeFilter.lastTwentyFourHours")}}</v-btn>
              <v-btn text @click="onQuickSelect('twoDays', $ponceConfig.timerTypes['diffHours'])">{{$t("TimeFilter.lastFortyEightHours")}}</v-btn>
            </div>
            <div class="time-filter-modal">
              <v-btn text @click="onQuickSelect('oneWeek', $ponceConfig.timerTypes['diffHours'])">{{$t("TimeFilter.lastSevenDays")}}</v-btn>
              <v-btn text @click="onQuickSelect('twoWeeks', $ponceConfig.timerTypes['diffHours'])">{{$t("TimeFilter.lastFourteenDays")}}</v-btn>
              <v-btn text @click="onQuickSelect('thisWeek', $ponceConfig.timerTypes['setWeek'])">{{$t("TimeFilter.thisWeek")}}</v-btn>
              <v-btn text @click="onQuickSelect('thisMonth', $ponceConfig.timerTypes['setMonth'])">{{$t("TimeFilter.thisMonth")}}</v-btn>
            </div>
          </v-layout>
        </v-card>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  props: ['timeRange'],
  data () {
    return {
      fromDateLocaleString: '',
      toDateLocaleString: '',
      timeSelectorDialog: false,
      fromDateString: '',
      fromTimeString: '',
      toDateString: '',
      toTimeString: ''
    }
  },
  mounted () {
    this.fromDateString = this.timeRange.from.toISOString()
    this.toDateString = this.timeRange.to.toISOString()
    this.fromDateLocaleString = this.timeRange.from.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
    this.toDateLocaleString = this.timeRange.to.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
  },
  methods: {
    onApply () {
      const newTimeRange = {}
      const newFromDate = this.fromDateString.split('T')[0]
      const newFromTime = this.fromDateString.split('T')[1]
      newTimeRange.from = new Date(`${newFromDate}T${newFromTime}`)
      this.fromDateLocaleString = newTimeRange.from.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})

      const newToDate = this.toDateString.split('T')[0]
      const newToTime = this.toDateString.split('T')[1]
      newTimeRange.to = new Date(`${newToDate}T${newToTime}`)
      this.toDateLocaleString = newTimeRange.from.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})

      this.$emit('update:timeRange', newTimeRange)
      this.$store.commit('setTimeRange', {from: newTimeRange.from.getTime(), to: newTimeRange.to.getTime(), type: this.$ponceConfig.timerTypes['diffHours']})

      this.timeSelectorDialog = false
    },
    onQuickSelect (range, type) {
      const limits = this.$ponceConfig.timeFrames(range)

      this.fromDateString = limits.from.toISOString()
      this.toDateString = limits.to.toISOString()

      this.fromDateLocaleString = limits.from.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
      this.toDateLocaleString = limits.to.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})

      this.$emit('update:timeRange', limits)
      this.$store.commit('setTimeRange', {from: limits.from.getTime(), to: limits.to.getTime(), type})

      this.timeSelectorDialog = false
    },
    refreshTime () {
      const timeRange = this.$store.getters.timeRange
      let newtimeRange = {
        from: new Date(timeRange.from),
        to: new Date(timeRange.to)
      }
      if (timeRange.type === this.$ponceConfig.timerTypes['diffHours']) {
        newtimeRange.to = new Date()
        this.$emit('update:timeRange', newtimeRange)
        this.$store.commit('setTimeRange', {from: newtimeRange.from.getTime(), to: newtimeRange.to.getTime(), type: timeRange.type})
      } else {
        const now = new Date()
        if (now > newtimeRange.to) {
          if (timeRange.type === this.$ponceConfig.timerTypes['setWeek']) {
            newtimeRange = this.$ponceConfig.timeFrames('thisWeek')
          } else if (timeRange.type === this.$ponceConfig.timerTypes['setMonth']) {
            newtimeRange = this.$ponceConfig.timeFrames('thisMonth')
          }
          this.$store.commit('setTimeRange', {from: newtimeRange.from.getTime(), to: newtimeRange.to.getTime(), type: timeRange.type})
        }
        this.$emit('update:timeRange', newtimeRange)
      }
      this.fromDateString = newtimeRange.from.toISOString()
      this.toDateString = newtimeRange.to.toISOString()
      this.fromDateLocaleString = newtimeRange.from.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
      this.toDateLocaleString = newtimeRange.to.toLocaleDateString('es-AR', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
    }
  }
}
</script>


// WEBPACK FOOTER //
// TimeFilter.vue?672014de